import React, { useState, useEffect } from 'react';
import './Splash.css';

export default function Splash() {
  const [visible, setVisible] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem('saskara_splash_seen');
    if (!seen) {
      setVisible(true);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const dismiss = () => {
    setFadingOut(true);
    sessionStorage.setItem('saskara_splash_seen', '1');
    document.body.style.overflow = '';
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <div className={`splash ${fadingOut ? 'splash--fade-out' : ''}`} onClick={dismiss}>
      <img src="/logo.png" alt="Saskara Record" className="splash__logo" />
      <p className="splash__tagline">Where Sounds Become Legacy</p>
      <span className="splash__hint">Ketuk di mana saja untuk masuk</span>
    </div>
  );
}
